import R from 'ramda'

const REACTION_ON_DISPLAY_TYPE = 'Reaction On'
const REACTION_ON_TRIGGER_TYPE = 'REACTION_ON'

const isReactionOnFormTrigger = R.propEq('type', REACTION_ON_DISPLAY_TYPE)

const convertReactionOnFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(REACTION_ON_TRIGGER_TYPE),
  data: R.prop('value'),
  operator: R.always('AND'),
  primary: R.T
})

export { isReactionOnFormTrigger, convertReactionOnFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/form-to-widget/reaction-on.js